import { render, staticRenderFns } from "./DatabaseList.vue?vue&type=template&id=9e4f3430&scoped=true&"
import script from "./DatabaseList.vue?vue&type=script&lang=ts&"
export * from "./DatabaseList.vue?vue&type=script&lang=ts&"
import style0 from "./DatabaseList.vue?vue&type=style&index=0&id=9e4f3430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4f3430",
  null
  
)

export default component.exports